const facilities = [
  {
    name: "Lee's Summit Post Office — Chipman Road",
    address: "400 NW Chipman Rd, Lee's Summit, MO 64063",
    hours: "Mon–Fri 8:30AM–5:00PM, Sat 9:00AM–12:00PM",
    services: ["Passport photos", "Acceptance agent"],
    note: "Main post office — highest volume in Lee's Summit. Call ahead to confirm passport agent availability.",
  },
  {
    name: "Lee's Summit Post Office — SE Oldham Pkwy",
    address: "701 SE Oldham Pkwy, Lee's Summit, MO 64081",
    hours: "Mon–Fri 8:30AM–5:00PM",
    services: ["Passport photos", "Acceptance agent"],
    note: "South Lee's Summit location, less busy than Chipman Road branch.",
  },
  {
    name: "Jackson County Courthouse — Independence",
    address: "308 W Kansas Ave, Independence, MO 64050",
    hours: "Mon–Fri 8:00AM–4:30PM",
    services: ["Passport acceptance", "Government ID accepted"],
    note: "County courthouse for Jackson County residents seeking official acceptance. Bring all supporting documents.",
  },
  {
    name: "Blue Springs Post Office",
    address: "400 NW R D Mize Rd, Blue Springs, MO 64015",
    hours: "Mon–Fri 9:00AM–5:00PM, Sat 9:00AM–12:00PM",
    services: ["Passport acceptance", "Passport photos"],
    note: "Convenient for Blue Springs, Grain Valley, and east Lee's Summit residents.",
  },
];

export default function LeeSummitAcceptanceFacilitiesSection() {
  return (
    <section id="acceptance-facilities" className="bg-[#F7F8FA] py-20 md:py-28">
      <div className="max-w-7xl mx-auto px-4 md:px-8">
        <div className="text-center mb-12">
          <p className="text-[#F6C344] text-xs font-bold uppercase tracking-[0.2em] mb-3">Acceptance Facilities</p>
          <h2 className="font-serif text-3xl md:text-4xl font-bold text-[#1A365D] mb-4">
            Passport Acceptance Locations Near Lee&apos;s Summit
          </h2>
          <p className="text-gray-500 max-w-2xl mx-auto text-base">
            First-time applicants and some renewals require an in-person acceptance step at an authorized facility. Here are the closest locations for Lee&apos;s Summit residents.
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
          {facilities.map((f, i) => (
            <div key={i} className="bg-white border border-gray-200 rounded-lg p-6">
              <h3 className="font-bold text-[#1A365D] text-base mb-1">{f.name}</h3>
              <p className="text-gray-500 text-sm mb-1 flex items-start gap-1.5">
                <i className="ri-map-pin-line text-[#F6C344] mt-0.5 flex-shrink-0"></i>{f.address}
              </p>
              <p className="text-gray-400 text-xs mb-3 flex items-start gap-1.5">
                <i className="ri-time-line text-[#F6C344] mt-0.5 flex-shrink-0"></i>{f.hours}
              </p>
              <div className="flex flex-wrap gap-2 mb-3">
                {f.services.map((s, j) => (
                  <span key={j} className="bg-[#EEF2F8] text-[#1A365D] text-xs font-semibold px-2.5 py-1 rounded-full">{s}</span>
                ))}
              </div>
              <p className="text-gray-400 text-xs italic">{f.note}</p>
            </div>
          ))}
        </div>

        <div className="mt-10 bg-[#1A365D] rounded-lg p-6 text-center">
          <p className="text-white text-sm mb-3">
            <strong className="text-[#F6C344]">Renewals:</strong> Most passport renewals do NOT require an in-person visit to an acceptance facility. Simply mail your documents directly to us.
          </p>
          <a href="https://fastpassportcenter.com/checkout/" className="inline-flex items-center gap-2 bg-[#F6C344] hover:bg-[#e5b430] text-[#1A365D] font-bold text-sm px-6 py-3 rounded-md transition-all whitespace-nowrap">
            Start Online — No Office Visit Required <i className="ri-arrow-right-line"></i>
          </a>
        </div>
      </div>
    </section>
  );
}